import ActionButtons from '@/apps/MainApp/views/Dashboard/ActionButtons/ActionButtons.vue'

export const registerActionColumn = (dashboard) => {
  dashboard.registerCustomColumn({
    name: 'action',
    label: 'monolith.shared.actions',
    component: ActionButtons,
    options: {
      searchable: false,
      sortable: false,
    },
  })
}
